import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=77e8a19c&lang=pug"
import script from "./FavoriteIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports